import { Component } from '@angular/core';

@Component({
  selector: 'ngx-one-column-custom-layout',
  styleUrls: ['./one-column-custom.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header-custom></ngx-header-custom>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="custom-menu-sidebar" responsive>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnCustomLayoutComponent {}
